export default "/assets/moderate-active.svg";